import {Component, Input, OnInit} from '@angular/core';
import {Contest} from '../../../model/contest/Contest';
import {TeacherExamStats} from '../../../model/stats/Stats';
import {Region} from '../../../model/location/Region';
import {School} from '../../../model/location/School';
import {Role} from '../../../model/auth/Role';
import {PaymentStatus} from '../../../model/Payment';
import {NotificationHandler} from '../../../helper/notification.handler';
import {ContestService} from '../../../service/contest.service';

@Component({
  selector: 'school-teachers-info',
  templateUrl: './school-teachers-info.component.html',
  styleUrls: ['./school-teachers-info.component.scss']
})
export class SchoolTeachersInfoComponent implements OnInit {

  @Input() mobileView = false;
  @Input() regions: Map<string, string> = new Map<string, string>();

  @Input() competitionId?: string;
  @Input() contest?: Contest;
  @Input() regionId?: string;
  @Input() schoolId?: string;

  @Input() set loadData(load: boolean | undefined) {
    if (load) {
      if (this.regionId && this.schoolId) {
        this.loadTeachers(this.competitionId, this.contest, new Region(this.regionId, ''), new School(this.schoolId, ''));
      }
    }
  };

  inProgress = false;

  teacherStats?: TeacherExamStats[];

  constructor(private contestService: ContestService) {
  }

  ngOnInit(): void {
  }

  loadTeachers(competitionId?: string, contest?: Contest, region?: Region, school?: School) {
    if (!competitionId || !contest || !region) return;

    this.inProgress = true;

    const page = {
      max_items: 50,
      asc: true
    };

    this.contestService.getEnrolledUsers(competitionId, contest.id, Role.Teacher, page, region, school)
      .subscribe(page => {
        const teachers = (page.content || []).filter(teacher => teacher.paymentStatus == PaymentStatus.successful);

        this.teacherStats = teachers.map(teacher => {
          const stats = new TeacherExamStats();

          stats.userId = teacher.id;
          stats.email = teacher.email;
          stats.phone = teacher.phone;
          stats.firstName = teacher.firstName;
          stats.lastName = teacher.lastName;
          stats.enrolledAt = teacher.enrolledAt;

          return stats;
        }).sort((t1, t2) => {
          const fNameCompare = (t1.firstName || '').localeCompare(t2.firstName || '');
          return fNameCompare == 0 ? (t1.lastName || '').localeCompare(t2.lastName || '') : fNameCompare;
        });

        this.inProgress = false;
      }, error => {
        this.inProgress = false;
        NotificationHandler.handleError($localize`:Notifications|Contest teachers fetch has failed message@@notifications-contest-teachers-fetch-failed-error:Contest teachers fetch has failed`, error);
      });
  }

}
